<div class="content-style-class">
  <div fxLayout="row">
    <h2 class="title-style">Gantt</h2>
  </div>
  <div class="content-block">
    <div class="dx-card responsive-paddings card-radius">
      <abc-gantt
        #gantt
        class="gantt-chart gantt-style tree-list-style"
        style="border-radius: 10px"
        taskListWidth="500"
        [scaleType]="scaleType"
        height="100%"
        (onContentReady)="contentReady($event)"
        (onContextMenuPreparing)="contextMenuPreparing($event)"
        (onTaskClick)="onCellClick($event)"
        [showDependencies]="true"
        (onTaskMoving)="$event.cancel = true"
        (onTaskDblClick)="$event.cancel = true"
      >
        <dxo-header-filter [visible]="true" [allowSearch]="true"></dxo-header-filter>
        <dxo-tasks
          [dataSource]="ganttDataSource"
          keyExpr="Id"
          parentIdExpr="ParentId"
          titleExpr="Title"
          startExpr="StartDate"
          endExpr="EndDate"
        >
        </dxo-tasks>
        <dxo-resources [dataSource]="resources"></dxo-resources>
        <dxo-resource-assignments [dataSource]="resourceAssignments"></dxo-resource-assignments>
        <dxi-column dataField="Title" caption="{{ dataService.res('Ubt-Gantt-Subject') }}"></dxi-column>
        <dxi-column
          dataField="StartDate"
          format="dd.MM.yyyy"
          caption="{{ dataService.res('Ubt-Measure-List-StartDate') }}"
          [width]="110"
          dataType="date"
        ></dxi-column>
        <dxi-column
          dataField="EndDate"
          format="dd.MM.yyyy"
          caption="{{ dataService.res('Ubt-Measure-List-EndDate') }}"
          [width]="110"
          dataType="date"
        ></dxi-column>
        <dxi-column dataField="type" [visible]="false"> </dxi-column>
        <dxi-column dataField="responsible" [visible]="false"> </dxi-column>
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-toolbar>
          <dxi-item name="collapseAll"></dxi-item>
          <dxi-item name="expandAll"></dxi-item>
          <dxi-item name="separator"></dxi-item>
          <dxi-item name="zoomIn"></dxi-item>
          <dxi-item name="zoomOut"></dxi-item>
          <dxi-item name="separator"></dxi-item>
          <dxi-item name="showResources"></dxi-item>
          <dxi-item widget="dxButton" [options]="customButtonOptions"></dxi-item>
          <dxi-item widget="dxButton" [options]="exportOptions"></dxi-item>
        </dxo-toolbar>
        <dxo-validation [autoUpdateParentTasks]="false"></dxo-validation>
        <dxo-editing [enabled]="false"></dxo-editing>
        <dxo-context-menu>
          <dxi-item
            text="{{ dataService.res('Ubt-MeasureTask-Create-Milestone') }}"
            name="add"
            icon="add"
            [disabled]="disableAddButton"
            [onClick]="createMilestone"
          >
          </dxi-item>
          <dxi-item
            text="{{ dataService.res('Ubt-MeasureTask-Create-Task') }}"
            name="add"
            icon="add"
            [disabled]="disableAddButton"
            [onClick]="createTask"
          >
          </dxi-item>
        </dxo-context-menu>
      </abc-gantt>
    </div>

    <ubt-geods-milestone #milestoneComponent (updateGantt)="updateGantt($event)"> </ubt-geods-milestone>

    <ubt-geods-task #taskComponent (updateGantt)="updateGantt($event)"> </ubt-geods-task>
  </div>
</div>
